export var SOCIAL;
(function(SOCIAL) {
    SOCIAL["INSTAGRAM"] = "https://www.instagram.com/faire_wholesale/";
    SOCIAL["FACEBOOK"] = "https://www.facebook.com/fairewholesale/";
    SOCIAL["TWITTER"] = "https://twitter.com/faire_wholesale";
})(SOCIAL || (SOCIAL = {}));
